import { type HeroTemplate, type HeroTemplateId } from '@/data/heroes';

export interface PartyMember {
  templateId: HeroTemplateId;
  level: number;
  hp: number;
  maxHp: number;
}

export interface Party {
  recruited: PartyMember[];
}

export const createParty = (): Party => ({ recruited: [] });

export const isRecruited = (party: Party, templateId: HeroTemplateId): boolean =>
  party.recruited.some((m) => m.templateId === templateId);

export const recruit = (party: Party, template: HeroTemplate): boolean => {
  if (isRecruited(party, template.id)) return false;
  party.recruited.push({
    templateId: template.id,
    level: 1,
    hp: template.baseHp,
    maxHp: template.baseHp,
  });
  return true;
};

// Promote a member to leader (index 0). Returns true if the order changed.
export const promoteToLeader = (party: Party, templateId: HeroTemplateId): boolean => {
  const idx = party.recruited.findIndex((m) => m.templateId === templateId);
  if (idx <= 0) return false;
  const member = party.recruited.splice(idx, 1)[0]!;
  party.recruited.unshift(member);
  return true;
};

export const leader = (party: Party): PartyMember | null =>
  party.recruited.length > 0 ? party.recruited[0]! : null;
